// src/components/ModaleAnnulation.jsx
// Fenêtre de confirmation avec motif, pour annuler une réservation ou un événement.

import React, { useState } from "react";
import { AlertTriangle, X } from "lucide-react";

const ModaleAnnulation = ({ titre, texte, motifs, onConfirmer, onFermer }) => {
    const [motif, setMotif] = useState(motifs[0]?.valeur);
    const [commentaire, setCommentaire] = useState("");
    const [envoi, setEnvoi] = useState(false);
    const [erreur, setErreur] = useState(null);

    const confirmer = async () => {
        setEnvoi(true);
        setErreur(null);
        try {
            await onConfirmer(motif, commentaire.trim() || null);
        } catch (e) {
            setErreur(e.message);
            setEnvoi(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 font-Poppins">
                <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-full bg-red-50 text-red-600 flex items-center justify-center shrink-0">
                        <AlertTriangle size={18} />
                    </div>
                    <div className="flex-1">
                        <h3 className="text-base font-bold text-gray-900">{titre}</h3>
                        <p className="text-xs text-gray-500 mt-1 leading-relaxed">{texte}</p>
                    </div>
                    <button onClick={onFermer} className="p-1 text-gray-400 hover:text-gray-600">
                        <X size={18} />
                    </button>
                </div>

                <label className="block text-xs font-semibold text-gray-700 mt-5 mb-1.5">Motif</label>
                <select
                    value={motif}
                    onChange={(e) => setMotif(e.target.value)}
                    className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-violet-500"
                >
                    {motifs.map((m) => (
                        <option key={m.valeur} value={m.valeur}>{m.label}</option>
                    ))}
                </select>

                <label className="block text-xs font-semibold text-gray-700 mt-4 mb-1.5">
                    Message (optionnel, visible par Thrundrz)
                </label>
                <textarea
                    value={commentaire}
                    onChange={(e) => setCommentaire(e.target.value)}
                    maxLength={500}
                    rows={3}
                    className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm resize-none focus:outline-none focus:border-violet-500"
                />

                {erreur && <p className="text-xs text-red-500 mt-2">{erreur}</p>}

                <div className="flex gap-2 mt-5">
                    <button
                        onClick={onFermer}
                        className="flex-1 py-2.5 rounded-xl border border-gray-200 text-sm font-semibold text-gray-700 hover:bg-gray-50"
                    >
                        Retour
                    </button>
                    <button
                        onClick={confirmer}
                        disabled={envoi}
                        className="flex-1 py-2.5 rounded-xl bg-red-600 hover:bg-red-700 text-white text-sm font-bold disabled:opacity-60"
                    >
                        {envoi ? "Remboursement…" : "Annuler et rembourser"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModaleAnnulation;